module.exports = __webpack_public_path__ + "static/media/small-spades.48ad0a54.svg";